import { createLogic } from 'redux-logic';
import { qffAuthInit } from 'lib/qffAuth';
import * as actions from '../actions';

const initApplication = createLogic({
  type: actions.loadApplication,
  process() {
    qffAuthInit();
  },
});

export default initApplication;
